// remotion/ProductVideo.jsx
import React from "react";
import { getInputProps } from 'remotion';
import {
  AbsoluteFill,
  Sequence,
  Img,
  Audio,
  Video,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import PriceBoxes from "./PriceBoxes";
import SocialBoxes, { SocialFooter } from "./SocialBoxes";
import MessageScreen from "./MessageScreen";

export default function ProductVideo(passedProps) {
  // Tenta pegar do getInputProps (funciona no Render/Studio)
  // Se falhar (no Player), usa passedProps
  let inputProps = {};
  try {
    inputProps = getInputProps();
  } catch (e) {
    inputProps = {};
  }

  const props = { ...inputProps, ...passedProps };

  const {
    products = [],
    selo = null,
    background = null,
    backgroundVideo = null,
    intro = null,
    intro_time = 4,
    audio_fundo = null,
    logo = null,
    cor_etiqueta = "#fff",
    bg_etiqueta = "transparent",
    fonte = null,
    width = null,
    height = null,
    formato = "story",
    // ===== NOVAS PROPS (req 3,4,5) =====
    msgAberturaEnabled = false,
    msgAberturaTexto = "",
    msgEncerramentoEnabled = false,
    msgEncerramentoTexto = "",
    redesEnabled = false,
    redesOutroEnabled = false,
    redesSociais = null,
    msgDuracaoSegs = 3,
    // ===== OUTRO (fechamento estilo intro) =====
    outroAudio = null,
    outroTime = 0,
    // ===== GRAVAÇÃO DO USUÁRIO =====
    audioGravado = null,
    modoGravando = false,
  } = props;




  const getLayoutByFormato = (formato) => {
  switch (formato) {
  case "story":
  case "tv_vertical": // 9:16
      return {
         seloIntro: {
          width: 600,
           top: "40%",
          left: "50%",
        },
        logoIntro: {
          width: 300,
          top: "60%",
          left: "50%"
        },
        titulo: {
          width: "100%",
          top: "27%",
          fontSize: 70,
        },
        imagem: {
          height: 600,
          top: "55%",
          left: "50%",

        },
        preco: {
          top: "75%",
          left: "50%",
          fontSize: 130,
        },
        logo:{
          width: 300,
          top: "10%",
          left: "25%",
        },
        selovideo:{
          width: 300,
          top: "10%",
          left: "55%",

        },
        validade: {
          top: "91%",
          left: "50%",
          fontSize: 30,
        }
        
      };

    case "feed": // 4:5 (1080x1350)
      return {
         seloIntro: {
          width: 500,
          top: "45%",
          left: "50%",
        },
        logoIntro: {
          width: 200,
          top: "62%",
          left: "50%"
        },
        titulo: {
          width: "100%",
          top: "25%",
          fontSize: 48,
        },
        imagem: {
          height: 510,
          top: "44%",
          left: "50%",
        },
        preco: {
          top: "70%",
          left: "50%",
          fontSize: 130,
        },
       logo:{
          width: 250,
          top: "5%",
        },
        validade: {
          top: "80%",
          left: "50%",
          fontSize: 22,
        },
        
      };

      case "tv_horizontal": // 16:9 (1920x1080)
      return {
         seloIntro: {
          width: 700,
          top: "50%",
          left: "35%"

        },
        logoIntro: {
          width: 380,
          top: "35%",
          left: "72%"
        },
        
        imagem: {
          height: 750,
          maxWidth: "48%",
          top: "52%",
          left: "30%"
        },
        titulo: {
          // Centralizado no mesmo eixo X do preço, com largura
          // aproximada da caixa de preço para começo/fim alinharem.
          width: "48%",
          top: "1%",
          left: "75%",
          centerX: true,
          fontSize: 85
        },
        preco: {
          top: "48%",
          left: "75%",
          fontSize: 180,
        },
        logo:{
          width: 240,
          top: "3%",
          right: "3%",
        },
        selovideo:{
          width: 300,
          top: "0%",
          left: "50%",
          transform: "translateX(-50%)",
        },
        validade: {
          top: "90%",
          left: "50%",
          fontSize: 24,
        },
        
      };



    default:
      return getLayoutByFormato("story");
  }
};


const renderPreco = (produto) => {
  if (!produto) return null;

  // Estilo para os textos de apoio (R$, De, Por, etc)
  const labelStyle = {
    fontSize: '0.45em', 
    lineHeight: 1,
    opacity: 0.9,
    fontWeight: 'bold',
  };

  // Estilo para o valor numérico em destaque
  const valueStyle = {
    fontSize: '1.4em', 
    lineHeight: 0.9,
    letterSpacing: '-2px',
    fontWeight: '900',
  };

  // Container padrão para alinhar o conteúdo
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  };

  switch (produto.tipopreco) {
    case "simples":
      return (
        /* Mudamos para row e usamos baseline para o R$ alinhar por baixo com o número */
        <div style={{ ...containerStyle, flexDirection: 'row', alignItems: 'baseline' }}>
          <span style={{ ...labelStyle, marginRight: 15 }}>R$</span>
          <span style={valueStyle}>{produto.preco}</span>
        </div>
      );

    case "dexpory":
      return (
        <div style={containerStyle}>
          <span style={{ ...labelStyle, textDecoration: 'line-through', marginBottom: 5, opacity: 0.7 }}>
            DE R$ {produto.precode}
          </span>
          <span style={labelStyle}>POR APENAS</span>
          <div style={{ display: 'flex', alignItems: 'baseline' }}>
            <span style={{ ...labelStyle, marginRight: 10 }}>R$</span>
            <span style={valueStyle}>{produto.precopor}</span>
          </div>
        </div>
      );

    case "levexpaguey":
      return (
        <div style={containerStyle}>
          <span style={{ ...labelStyle, marginBottom: 5 }}>{produto.titulodesconto}</span>
          <div style={{ display: 'flex', alignItems: 'baseline' }}>
            <span style={{ ...labelStyle, marginRight: 10 }}>R$</span>
            <span style={valueStyle}>{produto.precodesconto}</span>
          </div>
        </div>
      );

    case "parcelado":
      return (
        <div style={containerStyle}>
          <span style={{ ...labelStyle, marginBottom: 5 }}>{produto.tituloprecoparcelado}</span>
          <span style={valueStyle}>{produto.precoparcelado}</span>
          <span style={{ ...labelStyle, marginTop: 8, fontSize: '0.35em' }}>
            {produto.titulopreconormal} R$ {produto.precoavista}
          </span>
        </div>
      );

    case "customizado":
      return (
        <div style={{ ...valueStyle, textAlign: 'center' }}>
          {produto.precocustomizado}
        </div>
      );

    default:
      return null;
  }
};



  const frame = useCurrentFrame();
  const { fps, height: compHeight } = useVideoConfig();

  /**
   * Calcula layout adaptativo: ajusta a imagem para nunca invadir
   * o título (acima) nem o preço (abaixo).
   * Só atua em formatos verticais (story, feed, tv_vertical) onde os
   * elementos são empilhados. Em tv_horizontal o layout é lado-a-lado.
   */
  const computeAdaptiveLayout = (bl, h, fmt) => {
    const lo = JSON.parse(JSON.stringify(bl));

    const toPx = (v) => {
      if (typeof v === 'string' && v.endsWith('%')) return (parseFloat(v) / 100) * h;
      return parseFloat(v) || 0;
    };

    // Layout horizontal: imagem à esquerda, título/preço à direita
    if (fmt === 'tv_horizontal') {
      const maxH = Math.round(h * 0.80);
      if (lo.imagem.height > maxH) {
        lo.imagem.height = maxH;
      }

      // Posiciona o título logo acima do preço usando 'bottom'
      // Isso faz o texto "crescer para cima" — 1 ou 2 linhas ficam sempre colados ao preço
      const precoTopPx = toPx(lo.preco.top);
      const gap = 50;
      const titleBottomAtPx = precoTopPx - gap;
      const bottomFromEdge = h - titleBottomAtPx;
      delete lo.titulo.top;
      lo.titulo.bottom = `${((bottomFromEdge / h) * 100).toFixed(1)}%`;

      return lo;
    }

    // Borda inferior do título (posição + ~2 linhas de texto)
    const tituloTopPx = toPx(lo.titulo.top);
    const tituloFontPx = lo.titulo.fontSize || 70;
    const tituloBottomPx = tituloTopPx + tituloFontPx * 2;

    // Borda superior visual do preço (CSS top - padding do box)
    const precoTopPx = toPx(lo.preco.top);
    const precoVisualTopPx = precoTopPx - 40;

    // Espaço livre entre o título e o preço
    const gap = 10;
    const spaceStart = tituloBottomPx + gap;
    const spaceEnd = precoVisualTopPx - gap;
    const available = spaceEnd - spaceStart;

    if (available <= 0) return lo;

    // Só reduz se a imagem realmente ultrapassar o espaço
    let imgH = lo.imagem.height || 600;
    if (imgH > available) {
      imgH = Math.round(Math.max(200, available));
    }

    // Centraliza a imagem no espaço disponível
    // A imagem usa transform: translate(-50%, -40%)
    const bandCenter = (spaceStart + spaceEnd) / 2;
    const newCssTopPx = bandCenter - 0.1 * imgH;

    lo.imagem.height = imgH;
    lo.imagem.top = `${((newCssTopPx / h) * 100).toFixed(1)}%`;

    return lo;
  };

  const baseLayout = getLayoutByFormato(formato);
  const layout = computeAdaptiveLayout(baseLayout, compHeight, formato);

  const tempoIntro = Math.max(0, Math.floor(Number(intro_time) * fps));
  const tempoOutro = Math.max(0, Math.floor(Number(outroTime) * fps));
  const msgDur = Math.max(1, Math.floor(Number(msgDuracaoSegs) * fps));
  const tempoAbertura = msgAberturaEnabled && (msgAberturaTexto || '').trim() ? msgDur : 0;
  const temEncerramento = msgEncerramentoEnabled && (msgEncerramentoTexto || '').trim();
  const tempoEncerramento = temEncerramento ? msgDur : 0;
  const lista = Array.isArray(products) ? products : [];

  // Calcula duracao total de produtos
  let duracaoProdutosTotal = 0;
  for (const p of lista) {
    const d = Number(p?.tempo_audio) || 4;
    duracaoProdutosTotal += Math.max(1, Math.floor(d * fps));
  }

  const inicioIntro = tempoAbertura;
  const inicioProdutos = tempoAbertura + tempoIntro;
  const fimProdutos = inicioProdutos + duracaoProdutosTotal;
  const inicioOutro = fimProdutos;
  const inicioEncerramento = inicioOutro + tempoOutro;

  // Produto atual
  let produtoAtual = null;
  let frameProduto = 0;
  let duracaoProdutoFrames = 0;
  let startFrameProdutoAtual = 0;

  const timeAfterIntro = frame - inicioProdutos;

  if (timeAfterIntro >= 0 && timeAfterIntro < duracaoProdutosTotal) {
    let acumulado = 0;
    for (let i = 0; i < lista.length; i++) {
      const duracaoSegs = Number(lista[i]?.tempo_audio) || 4;
      const duracao = Math.max(1, Math.floor(duracaoSegs * fps));
      if (timeAfterIntro < acumulado + duracao) {
        produtoAtual = lista[i];
        frameProduto = timeAfterIntro - acumulado;
        duracaoProdutoFrames = duracao;
        startFrameProdutoAtual = inicioProdutos + acumulado;
        break;
      }
      acumulado += duracao;
    }
  }

  const fade = (f, total) => {
    if (total <= 0) return 1;
    return interpolate(f, [0, 15, Math.max(total - 15, 16), total], [0, 1, 1, 0], { extrapolateRight: "clamp" });
  };

  const getUrl = (filePath) => {
    if (!filePath) return null;
    if (typeof filePath !== "string") return null;
    if (filePath.startsWith("http") || filePath.startsWith("data:") || filePath.startsWith("blob:") || filePath.startsWith("file://"))
      return filePath;
    return `file://${filePath.replace(/\\/g, "/")}`;
  };

  const bgUrl = getUrl(background);
  const bgVideoUrl = getUrl(backgroundVideo);
  const seloUrl = getUrl(selo);
  const logoUrl = getUrl(logo);
  const audioFundoUrl = getUrl(audio_fundo);
  const introUrl = getUrl(intro);

  return (
    <AbsoluteFill>
      {/* ===== BACKGROUND COM MOVIMENTO ===== */}
      {bgUrl && (
        <AbsoluteFill
          style={{
            width: "100%",
            height: "100%",
            backgroundImage: `url("${bgUrl}")`,
            backgroundSize: "cover", // força largura 100%
            
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            transform: `
              scale(1.03)
              translateX(${Math.cos(frame / 10) * 20}px)
              translateY(${Math.sin(frame / 10) * 20}px)
            `,
          }}
        />
      )}

      {/* ===== VIDEO DE FUNDO ===== */}
      {bgVideoUrl && (
        <AbsoluteFill>
          <Video
            src={bgVideoUrl}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              opacity: 0.7,
              mixBlendMode: "screen",
            }}
            startFrom={0}
            loop
            muted
          />
        </AbsoluteFill>
      )}

      {/* ===== AUDIO DE FUNDO ===== */}
      {audioFundoUrl && <Audio src={audioFundoUrl} volume={0.05} />}

      {/* ===== ÁUDIO GRAVADO (modo gravar voz) ===== */}
      {audioGravado && (
        <Audio src={getUrl(audioGravado)} />
      )}

      {/* ===== INTRO ===== */}
      {!modoGravando && introUrl && tempoIntro > 0 && (
        <Sequence from={inicioIntro + 30} durationInFrames={tempoIntro}>
          <Audio src={introUrl} />
        </Sequence>
      )}

      {/* ===== OUTRO (áudio de fechamento) ===== */}
      {!modoGravando && outroAudio && tempoOutro > 0 && (
        <Sequence from={inicioOutro} durationInFrames={tempoOutro}>
          <Audio src={getUrl(outroAudio)} />
        </Sequence>
      )}

      {/* ===== SELO ===== */}
      {seloUrl && frame >= inicioIntro && frame < inicioProdutos && (
        <Img
          src={seloUrl}
          style={{
            width: layout.seloIntro.width,
            position: "absolute",
            top: layout.seloIntro.top,
            left: layout.seloIntro.left,
            transform: `
              translate(-50%, -50%)
              rotateY(${interpolate(frame - inicioIntro, [0, tempoIntro * 0.1], [0, 360], { extrapolateRight: "clamp" })}deg)
              scale(${interpolate(
                spring({ frame: Math.max((frame - inicioIntro) - tempoIntro * 0.1, 0), fps, config: { damping: 1, stiffness: 200 } }),
                [0, 1],
                [0.9, 1.1]
              )})
            `,
            opacity: fade(frame - inicioIntro, tempoIntro),
            transformStyle: "preserve-3d",
          }}
        />
      )}

      {/* ===== LOGO DURANTE INTRO ===== */}
      {logoUrl && frame >= inicioIntro && frame < inicioProdutos && (
        <Img
          src={logoUrl}
          style={{
            width: layout.logoIntro.width,
            position: "absolute",
            top: layout.logoIntro.top,
            left: layout.logoIntro.left,
            transform: `translateX(-50%) scale(${interpolate(
              spring({ frame: Math.max((frame - inicioIntro) * 0.2, 0), fps, config: { damping: 1, stiffness: 200 } }),
              [0, 1],
              [0.9, 1.2]
            )})`,
            opacity: fade(frame - inicioIntro, tempoIntro),
            
          }}
        />
      )}

      {/* ===== SELO DURANTE OUTRO ===== */}
      {seloUrl && tempoOutro > 0 && frame >= inicioOutro && frame < inicioEncerramento && (
        <Img
          src={seloUrl}
          style={{
            width: layout.seloIntro.width,
            position: "absolute",
            top: layout.seloIntro.top,
            left: layout.seloIntro.left,
            transform: `
              translate(-50%, -50%)
              scale(${interpolate(
                spring({ frame: Math.max(frame - inicioOutro, 0), fps, config: { damping: 1, stiffness: 200 } }),
                [0, 1],
                [0.9, 1.05]
              )})
            `,
            opacity: fade(frame - inicioOutro, tempoOutro),
          }}
        />
      )}

      {/* ===== LOGO DURANTE OUTRO ===== */}
      {logoUrl && tempoOutro > 0 && frame >= inicioOutro && frame < inicioEncerramento && (
        <Img
          src={logoUrl}
          style={{
            width: layout.logoIntro.width,
            position: "absolute",
            top: layout.logoIntro.top,
            left: layout.logoIntro.left,
            transform: `translateX(-50%) scale(${interpolate(
              spring({ frame: Math.max((frame - inicioOutro) * 0.2, 0), fps, config: { damping: 1, stiffness: 200 } }),
              [0, 1],
              [0.9, 1.1]
            )})`,
            opacity: fade(frame - inicioOutro, tempoOutro),
          }}
        />
      )}

      {/* ===== PRODUTO ===== */}
      {produtoAtual && (
        <>
          <div style={{ opacity: fade(frameProduto, duracaoProdutoFrames), overflow: 'hidden', width: '100%', height: '100%', position: 'relative' }}>
            {/* TÍTULO PULSANTE */}
            <div
              style={{
                position: "absolute",
                ...(layout.titulo.top != null ? { top: layout.titulo.top } : {}),
                ...(layout.titulo.bottom != null ? { bottom: layout.titulo.bottom } : {}),
                left: layout.titulo.left,
                textAlign: "center",
                fontSize: layout.titulo.fontSize,
                fontWeight: "bold",
                width: layout.titulo.width,
                // Quando centerX=true, o título é centralizado horizontalmente
                // pelo próprio `left` (via translateX(-50%)) — usado para
                // alinhar o início/fim do título com a caixa de preço.
                paddingLeft: layout.titulo.centerX ? 0 : 100,
                paddingRight: layout.titulo.centerX ? 0 : 100,
                lineHeight:1,
                 boxSizing: "border-box",
                fontFamily: fonte,
                color: "#fff",
                textShadow: "2px 2px 4px rgba(0,0,0,.6)",
                transform: `${layout.titulo.centerX ? 'translateX(-50%) ' : ''}scale(${interpolate(
                  spring({ frame: Math.max(frameProduto - 0, 0), fps, config: { damping: 2, stiffness: 90 } }),
                  [0, 1],
                  [0.9, 1.1]
                )})`,
              }}
            >
              {produtoAtual.titulo}
            </div>

            {/* IMAGEM PULSANTE */}
            {produtoAtual.imagem && (
              <Img
                src={getUrl(produtoAtual.imagem)}
                style={{
                  height: layout.imagem.height,
                  maxWidth: layout.imagem.maxWidth || '90%',
                  maxHeight: '85%',
                  position: "absolute",
                  top: layout.imagem.top,
                  left: layout.imagem.left,
                  objectFit: "contain",
                  transform: `translate(-50%, -40%) scale(${interpolate(
                    spring({ frame: Math.max(frameProduto - 5, 0), fps, config: { damping: 2, stiffness: 90 } }),
                    [0, 1],
                    [0.95, 1.05]
                  )})`,
                }}
              />
            )}

           {/* PREÇO — caixas separadas (req. 10) */}
{(() => {
  const tipoPreco = produtoAtual.tipopreco;
  const temDoisCards = tipoPreco === 'dexpory' || tipoPreco === 'pagamento';
  // Quando há 2 cards, sobe um pouco para não colidir com o rodapé
  let ajusteY = temDoisCards ? -6 : 0; // % do container

  // ──────────────────────────────────────────────────────────────
  // AJUSTES POR FORMATO (quando há 2 cards)
  // Valores em % do container. Positivo = move para baixo/direita.
  // Edite aqui se quiser empurrar o bloco do preço para algum lado
  // em um formato específico.
  // ──────────────────────────────────────────────────────────────
  let ajusteX = 0; // % horizontal extra
  if (temDoisCards) {
    switch (formato) {
      case 'story':
      case 'tv_vertical':
        ajusteX = 0;   // ex.: -5 puxa um pouco para a esquerda
        ajusteY += 0;  // ex.: -2 sobe mais
        break;
      case 'feed':
        ajusteX = 0;
        ajusteY += 0;
        break;
      case 'tv_horizontal':
        ajusteX = -10;
        ajusteY += 0;
        break;
      default:
        break;
    }
  }

  // Se TODAS as redes sociais estão ativas (5) e o rodapé está exibido,
  // sobe mais um pouco — somente em formatos story/painel (tv_vertical).
  const habRedes = (redesSociais && redesSociais._config && redesSociais._config.habilitados) || {};
  const todasRedesAtivas =
    !!habRedes.instagram && !!habRedes.whatsapp && !!habRedes.facebook &&
    !!habRedes.site && !!habRedes.endereco;
  const formatoVerticalGrande = formato === 'story' || formato === 'tv_vertical';
  if (redesEnabled && todasRedesAtivas && formatoVerticalGrande) {
    ajusteY -= 35; // sobe mais para liberar espaço do rodapé maior
  }
  return (
<div
  style={{
    position: "absolute",
    top: layout.preco.top,
    left: layout.preco.left,
    transform: `translate(calc(-50% + ${ajusteX}%), ${ajusteY}%) scale(${interpolate(
      spring({ frame: Math.max(frameProduto - 10, 0), fps, config: { damping: 2, stiffness: 90 } }),
      [0, 1],
      [0.9, 1.05]
    )})`,
    width: 'auto',
    maxWidth: '92%',
    display: 'flex',
    justifyContent: 'center',
    zIndex: 5,
  }}
>
  <PriceBoxes
    produto={produtoAtual}
    fonte={fonte}
    cor={cor_etiqueta}
    bg={bg_etiqueta && bg_etiqueta !== 'transparent' ? bg_etiqueta : '#73207C'}
    fontSize={layout.preco.fontSize}
  />

  {/* UNIDADE — badge externa (sempre visível quando houver unidade) */}
  {produtoAtual.unidade && produtoAtual.unidade !== "undefined" && (
    <div
      style={{
        position: "absolute",
        top: -10,
        right: 0,
        fontSize: layout.preco.fontSize * 0.25,
        fontWeight: "800",
        background: "rgba(0,0,0,0.6)",
        padding: "3px 8px",
        borderRadius: 12,
        color: "#fff",
        textTransform: "lowercase",
        letterSpacing: "1px",
      }}
    >
      {produtoAtual.unidade}
    </div>
  )}

  {/* OBSERVAÇÕES — footer absoluto, 100% da largura do preço, sem afetar o tamanho da caixa */}
  {produtoAtual.observacoes && (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        width: "100%",
        marginTop: 8,
        textAlign: "center",
        fontFamily: fonte,
        fontSize: layout.preco.fontSize * 0.22,
        fontWeight: 600,
        color: "#fff",
        textShadow: "1px 1px 6px rgba(0,0,0,0.8)",
        background: "rgba(0,0,0,0.7)",
        padding: "8px 14px",
        borderRadius: 12,
        boxSizing: "border-box",
        lineHeight: 1.2,
        zIndex: 6,
        opacity: interpolate(frameProduto, [0, 20], [0, 1], { extrapolateRight: "clamp" }),
      }}
    >
      {produtoAtual.observacoes}
    </div>
  )}
</div>
  );
})()}

{/* VALIDADE */}
{(produtoAtual.validade_inicio || produtoAtual.validade_final) && (
  <div
    style={{
      position: "absolute",
      top: layout.validade?.top || "91%",
      left: layout.validade?.left || "50%",
      transform: "translateX(-50%)",
      textAlign: "center",
      fontSize: layout.validade?.fontSize || 28,
      fontFamily: fonte,
      color: "#fff",
      textShadow: "1px 1px 6px rgba(0,0,0,0.8)",
      background: "rgba(0,0,0,0.5)",
      padding: "10px 30px",
      borderRadius: 15,
      whiteSpace: "nowrap",
      opacity: interpolate(frameProduto, [0, 20], [0, 1], { extrapolateRight: "clamp" }),
    }}
  >
    {produtoAtual.validade_inicio && produtoAtual.validade_final && (
      <div style={{ fontWeight: "700" }}>
        Válido de {produtoAtual.validade_inicio.split("-").reverse().join("/")} até {produtoAtual.validade_final.split("-").reverse().join("/")}
      </div>
    )}
    {produtoAtual.validade_inicio && !produtoAtual.validade_final && (
      <div style={{ fontWeight: "700" }}>
        A partir de {produtoAtual.validade_inicio.split("-").reverse().join("/")}
      </div>
    )}
    {!produtoAtual.validade_inicio && produtoAtual.validade_final && (
      <div style={{ fontWeight: "700" }}>
        Válido até {produtoAtual.validade_final.split("-").reverse().join("/")}
      </div>
    )}
  </div>
)}


          </div>

          {/* ===== ÁUDIO DO PRODUTO ===== */}
          {!modoGravando && produtoAtual.audio && (
            <Sequence from={startFrameProdutoAtual} durationInFrames={duracaoProdutoFrames}>
              <Audio src={getUrl(produtoAtual.audio)} />
            </Sequence>
          )}
        </>
      )}

      {/* LOGO FINAL */}
      {logoUrl && frame >= inicioProdutos && frame < fimProdutos && layout.selovideo && (
        <>
          {/* SELO — lado esquerdo */}
          {seloUrl && (
            <Img
              src={seloUrl}
              style={{
                width: layout.selovideo.width,
                position: "absolute",
                top: layout.selovideo.top,
                left: layout.selovideo.left,
                ...(layout.selovideo.right ? { right: layout.selovideo.right } : {}),
                ...(layout.selovideo.transform ? { transform: layout.selovideo.transform } : {}),
              }}
            />
          )}
          {/* LOGO */}
          <Img
            src={logoUrl}
            style={{
              width: layout.logo.width,
              position: "absolute",
              top: layout.logo.top,
              ...(layout.logo.right ? { right: layout.logo.right } : {}),
              ...(layout.logo.left ? { left: layout.logo.left } : {}),
            }}
          />
        </>
      )}

      {/* LOGO FINAL — formatos que não têm selovideo (centralizado) */}
      {logoUrl && frame >= inicioProdutos && frame < fimProdutos && !layout.selovideo && (
        <div style={{
            width: "100%",
            position: "absolute",
            top: layout.logo.top,
            left: layout.logo.left,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "40px",
          }}>
          <Img
            src={logoUrl}
            style={{ width: layout.logo.width }}
          />
          {seloUrl && (
            <Img
              src={seloUrl}
              style={{ width: layout.logo.width }}
            />
          )}
        </div>
      )}

      {/* ===== MENSAGEM DE ABERTURA (req. 3) ===== */}
      {tempoAbertura > 0 && (
        <Sequence from={0} durationInFrames={tempoAbertura}>
          <AberturaScreen texto={msgAberturaTexto} fonte={fonte} formato={formato} />
        </Sequence>
      )}

      {/* ===== MENSAGEM DE ENCERRAMENTO + REDES (req. 4,5,6) ===== */}
      {tempoEncerramento > 0 && (
        <Sequence from={inicioEncerramento} durationInFrames={tempoEncerramento}>
          <EncerramentoScreen
            texto={msgEncerramentoEnabled ? msgEncerramentoTexto : ''}
            fonte={fonte}
            formato={formato}
            showSocial={!!redesEnabled}
            redes={redesSociais}
          />
        </Sequence>
      )}

      {/* ===== RODAPÉ DE REDES SOCIAIS (durante exibição dos produtos) ===== */}
      {redesEnabled && redesSociais && frame >= inicioProdutos && frame < fimProdutos && (
        <SocialFooter
          redes={redesSociais}
          fonte={fonte}
          formato={formato}
          corFundo={bg_etiqueta && bg_etiqueta !== 'transparent' ? bg_etiqueta : '#73207C'}
          corTexto={cor_etiqueta}
        />
      )}

      {/* ===== RODAPÉ DE REDES SOCIAIS (durante o fechamento/outro) ===== */}
      {redesOutroEnabled && redesSociais && tempoOutro > 0 && frame >= inicioOutro && frame < inicioEncerramento && (
        <SocialFooter
          redes={redesSociais}
          fonte={fonte}
          formato={formato}
          corFundo={bg_etiqueta && bg_etiqueta !== 'transparent' ? bg_etiqueta : '#73207C'}
          corTexto={cor_etiqueta}
        />
      )}

    </AbsoluteFill>
  );
}

// Wrappers (recebem useCurrentFrame relativo à Sequence)
function AberturaScreen({ texto, fonte, formato }) {
  return <MessageScreen texto={texto} fonte={fonte} formato={formato} background="linear-gradient(135deg,#3C005A 0%,#73207C 100%)" />;
}
function EncerramentoScreen({ texto, fonte, formato, showSocial, redes }) {
  return <MessageScreen texto={texto} fonte={fonte} formato={formato} background="linear-gradient(135deg,#0F0A15 0%,#3C005A 100%)" showSocial={showSocial} redes={redes} />;
}
